import { render, staticRenderFns } from "./promo-code-field.vue?vue&type=template&id=5ca9e907&"
import script from "./promo-code-field.vue?vue&type=script&lang=ts&"
export * from "./promo-code-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports